<mat-card appearance="outlined" class="mt-4">
    <div *ngIf="isStatusBarVisible"
         class="status-bar"
         [ngClass]="statusBarStateClass()"></div>
    <div class="content">
        <div>
            <mat-card-title><a (click)="onEdit()">{{ item.label(35) }}</a></mat-card-title>
            <mat-card-subtitle>
              <ng-container *ngIf="item.type.isUserField" i18n>User field -</ng-container>
              {{ item.type.name }} |
              {{ getRequiredOrOptional() }}
            </mat-card-subtitle>
        </div>
        <div>
            <button mat-icon-button
                    aria-label="Re-order form field"
                    i18n-aria-label
                    cdkDragHandle>
              <mat-icon>swap_vert</mat-icon>
            </button>
            <button mat-icon-button
                    [matMenuTriggerFor]="assignMenu">
                    <mat-icon>more_horiz</mat-icon>
            </button>
            <mat-menu #assignMenu="matMenu">
              <ng-container *ngIf="!canChangePermission">
                <div mat-menu-item class="small" [disabled]="true" i18n>
                  To assign select Role & State
                </div>
                <mat-divider></mat-divider>
              </ng-container>
              <button *ngIf="canBeAssignedChangedToReadOnly()"
                      mat-menu-item
                      (click)="onSetPermission(false, false)"
                      [disabled]="!canChangePermission">
                <mat-icon>visibility</mat-icon>
                <span>{{ getAssignAsOrChangeToReadOnly() }}</span>
              </button>
              <button *ngIf="canBeAssignedChangedToEditable()"
                      mat-menu-item
                      (click)="onSetPermission(true, false)"
                      [disabled]="!canChangePermission">
                <mat-icon>create</mat-icon>
                <span>{{ getAssignAsOrChangeToEditable() }}</span>
              </button>
              <button *ngIf="hasPermission"
                      mat-menu-item
                      (click)="onRemovePermission(false)">
                <mat-icon>delete</mat-icon>
                <span i18n>Unassign</span>
              </button>
              <mat-divider></mat-divider>
              <button mat-menu-item (click)="onMoveUp()" [disabled]="isFirst">
                <mat-icon>arrow_upward</mat-icon>
                <span i18n>Move up</span>
              </button>
              <button mat-menu-item (click)="onMoveDown()" [disabled]="isLast">
                <mat-icon>arrow_downward</mat-icon>
                <span i18n>Move down</span>
              </button>
              <button mat-menu-item (click)="onEdit()">
                <mat-icon>settings</mat-icon>
                <span i18n>Edit field</span>
              </button>
            </mat-menu>
        </div>
    </div>
</mat-card>
